import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Loader2, Mail, CheckCircle2, AlertTriangle, Cake, RefreshCw } from "lucide-react";

const STATUS_COLOR = {
  sent: { bg: "#D8F3DC", color: "#1B4332", icon: CheckCircle2 },
  queued: { bg: "#FCE7C9", color: "#9A6020", icon: Loader2 },
  failed: { bg: "#FADED7", color: "#9A3412", icon: AlertTriangle },
  mocked: { bg: "#DCE9F0", color: "#1F4863", icon: AlertTriangle },
};

export default function Notifications() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);

  const load = async () => {
    setLoading(true);
    const { data } = await api.get("/notifications");
    setItems(data); setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const triggerBirthdays = async () => {
    setBusy(true);
    const { data } = await api.post("/notifications/trigger-birthdays");
    alert(`Birthday wishes triggered for ${data.count} employee(s).`);
    setBusy(false); load();
  };

  return (
    <div className="space-y-6" data-testid="notifications-page">
      <header className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <div className="kpi-label" style={{ color: "var(--color-secondary)" }}>Outbound</div>
          <h1 className="font-heading text-3xl font-bold tracking-tight mt-1">Notifications</h1>
          <p className="text-stone-600 mt-1 text-sm">Email log with delivery status. Mark as MOCKED if Resend API key isn't configured.</p>
        </div>
        <div className="flex gap-2">
          <button onClick={triggerBirthdays} disabled={busy} data-testid="trigger-birthdays-button"
                  className="flex items-center gap-2 px-4 py-2 rounded-md text-white font-medium" style={{ background: "var(--color-secondary)" }}>
            <Cake className="w-4 h-4" /> Send Birthday Wishes
          </button>
          <button onClick={load} className="flex items-center gap-2 px-3 py-2 rounded-md border border-stone-300 text-sm">
            <RefreshCw className="w-4 h-4" /> Refresh
          </button>
        </div>
      </header>

      {loading ? <div className="flex items-center justify-center py-24"><Loader2 className="w-6 h-6 animate-spin text-primary" /></div> : (
        <div className="card-flat overflow-hidden p-0">
          <table className="w-full text-sm" data-testid="notifications-table">
            <thead><tr className="text-left text-xs uppercase tracking-wider text-stone-500 bg-stone-50/60">
              <th className="px-6 py-3">Time</th><th>Channel</th><th>To</th><th>Subject</th><th>Status</th>
            </tr></thead>
            <tbody>
              {items.length === 0 && <tr><td colSpan="5" className="py-10 text-center text-stone-500">No notifications yet. Approve a leave or TA/DA claim to fire an email.</td></tr>}
              {items.map((n) => {
                const c = STATUS_COLOR[n.status] || STATUS_COLOR.queued;
                return (
                  <tr key={n.id} className="border-t border-stone-100">
                    <td className="px-6 py-3 text-stone-600 whitespace-nowrap">{new Date(n.created_at).toLocaleString("en-IN", { dateStyle: "short", timeStyle: "short" })}</td>
                    <td className="px-6 py-3"><Mail className="w-4 h-4 text-stone-500" /></td>
                    <td className="px-6 py-3 font-medium">{n.to}</td>
                    <td className="px-6 py-3 text-stone-600">{n.subject}</td>
                    <td className="px-6 py-3">
                      <span className="status-pill capitalize" style={{ background: c.bg, color: c.color }}>
                        <c.icon className={`w-3 h-3 ${n.status === "queued" ? "animate-spin" : ""}`} /> {n.status}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
